import React from 'react';
import { Twitter, Linkedin, Github } from 'lucide-react';
export function Footer() {
  const columns = [{
    title: 'Products',
    links: [{
      label: 'Orchestrate',
      href: '#products/orchestrate'
    }, {
      label: 'Payments',
      href: '#products/payments'
    }, {
      label: 'Wallets',
      href: '#products/wallets'
    }, {
      label: 'Exchange',
      href: '#products/exchange'
    }, {
      label: 'Compliance',
      href: '#products/compliance'
    }, {
      label: 'Tokenize',
      href: '#products/tokenize'
    }]
  }, {
    title: 'Developers',
    links: [{
      label: 'Documentation',
      href: '#/docs'
    }, {
      label: 'API Reference',
      href: '#/docs/api-reference'
    }, {
      label: 'SDKs',
      href: '#'
    }, {
      label: 'Status',
      href: '#'
    }, {
      label: 'Sandbox',
      href: '#'
    }]
  }, {
    title: 'Legal',
    links: [{
      label: 'Privacy Policy',
      href: '#'
    }, {
      label: 'Terms of Service',
      href: '#'
    }, {
      label: 'Cookie Policy',
      href: '#'
    }, {
      label: 'Licenses',
      href: '#'
    }]
  }];
  return <footer className="bg-slate-50 border-t border-slate-200 pt-12 sm:pt-16 pb-12" data-id="element-67">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-68">
        {/* Logo Section - Centered on mobile */}
        <div className="text-center sm:text-left mb-10 sm:mb-0 sm:hidden" data-id="element-69">
          <a href="#" className="inline-flex items-center gap-2 font-bold text-lg tracking-tight text-slate-900 mb-4" data-id="element-70">
            <div className="w-5 h-5 bg-slate-900 rounded-sm" data-id="element-71" />
            Obseq
          </a>
          <p className="text-sm text-slate-500 mb-6 max-w-xs mx-auto" data-id="element-72">
            Global money infrastructure for the modern economy. Regulated,
            secure, and programmable.
          </p>
          <div className="flex gap-4 justify-center" data-id="element-73">
            <a href="#" className="w-9 h-9 bg-slate-200 hover:bg-slate-300 rounded-full flex items-center justify-center text-slate-600 hover:text-slate-900 transition-colors" data-id="element-74">
              <Twitter className="w-4 h-4" data-id="element-75" />
            </a>
            <a href="#" className="w-9 h-9 bg-slate-200 hover:bg-slate-300 rounded-full flex items-center justify-center text-slate-600 hover:text-slate-900 transition-colors" data-id="element-76">
              <Linkedin className="w-4 h-4" data-id="element-77" />
            </a>
            <a href="#" className="w-9 h-9 bg-slate-200 hover:bg-slate-300 rounded-full flex items-center justify-center text-slate-600 hover:text-slate-900 transition-colors" data-id="element-78">
              <Github className="w-4 h-4" data-id="element-79" />
            </a>
          </div>
        </div>

        {/* Links Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-4 gap-8 sm:gap-8 mb-12" data-id="element-80">
          {/* Logo - Desktop only */}
          <div className="hidden sm:block" data-id="element-81">
            <a href="#" className="flex items-center gap-2 font-bold text-xl tracking-tight text-slate-900 mb-4" data-id="element-82">
              <div className="w-6 h-6 bg-slate-900 rounded-sm" data-id="element-83" />
              Obseq
            </a>
            <p className="text-sm text-slate-500 mb-6 max-w-xs" data-id="element-84">
              Global money infrastructure for the modern economy. Regulated,
              secure, and programmable.
            </p>
            <div className="flex gap-3" data-id="element-85">
              <a href="#" className="w-9 h-9 bg-slate-200 hover:bg-slate-300 rounded-full flex items-center justify-center text-slate-600 hover:text-slate-900 transition-colors" data-id="element-86">
                <Twitter className="w-4 h-4" data-id="element-87" />
              </a>
              <a href="#" className="w-9 h-9 bg-slate-200 hover:bg-slate-300 rounded-full flex items-center justify-center text-slate-600 hover:text-slate-900 transition-colors" data-id="element-88">
                <Linkedin className="w-4 h-4" data-id="element-89" />
              </a>
              <a href="#" className="w-9 h-9 bg-slate-200 hover:bg-slate-300 rounded-full flex items-center justify-center text-slate-600 hover:text-slate-900 transition-colors" data-id="element-90">
                <Github className="w-4 h-4" data-id="element-91" />
              </a>
            </div>
          </div>

          {/* Link Columns - Stacked and centered on mobile */}
          {columns.map(col => <div key={col.title} className="text-center sm:text-left" data-id="element-92">
              <h3 className="font-semibold text-slate-900 mb-4" data-id="element-93">{col.title}</h3>
              <ul className="space-y-3" data-id="element-94">
                {col.links.map(link => <li key={link.label} data-id="element-95">
                    <a href={link.href} className="text-sm text-slate-500 hover:text-slate-900 transition-colors" data-id="element-96">
                      {link.label}
                    </a>
                  </li>)}
              </ul>
            </div>)}
        </div>

        <div className="pt-8 border-t border-slate-200" data-id="element-97">
          <p className="text-sm text-slate-500 text-center" data-id="element-98">
            © {new Date().getFullYear()} Obseq Inc. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}